import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/about', label: 'About' },
    { to: '/qualifications', label: 'Qualifications' },
    { to: '/services', label: 'Services' },
    { to: '/products', label: 'Products' },
    { to: '/testimonials', label: 'Testimonials' },
    { to: '/contact', label: 'Contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-[#F3F0EB]/98 backdrop-blur-sm shadow-sm' : 'bg-[#F3F0EB]'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center">
          <Link to="/">
            <img
              src="https://www.museshaircwb.com/wp-content/uploads/2024/01/cropped-Muses-Hair-Logo-1.png"
              alt="Muses Hair CWB"
              className="h-11 w-auto cursor-pointer"
            />
          </Link>
        </div>
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-sm font-medium transition-colors ${
                location.pathname === link.to
                  ? 'text-gray-900'
                  : 'text-gray-800 hover:text-gray-600'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
        <Link
          to="/contact"
          className="bg-gray-800 hover:bg-gray-700 text-white px-6 py-2.5 rounded-md text-sm font-medium transition-all whitespace-nowrap cursor-pointer"
        >
          Book Consultation
        </Link>
      </div>
    </nav>
  );
}
